import { Fetch } from 'lib';
import type {
  BaseAttributeSummary,
  Product,
  ProductFileInfoSummary,
  ProductPackagingSummary,
  ProductVariantSummary,
  SubProductSummary,
} from 'types';

type RequestResponses = Product;

type RequestParameters = {};

type RequestBody = Prettify<
  Pick<
    Product,
    | 'name'
    | 'identifier'
    | 'slug'
    | 'isRecommended'
    | 'callForPrice'
    | 'showPostingStatus'
    | 'description'
    | 'productType'
    | 'seo'
    | 'status'
  > &
    Partial<
      Record<'brandId' | 'mainCategoryId' | 'breadcrumbCategoryId', string>
    > &
    Record<
      | 'otherCategoriesIds'
      | 'tagsIds'
      | 'variableAttributesIds'
      | 'complementsIds',
      string[]
    > &
    Record<'subProducts', SubProductSummary[]> &
    Record<'baseAttributes', BaseAttributeSummary[]> &
    Record<'packagingInfo', ProductPackagingSummary[]> &
    Record<'pictures' | 'documents', ProductFileInfoSummary[]> &
    Record<'variants', ProductVariantSummary[]>
>;

const createProduct = async (body: RequestBody) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminProduct/createProduct',
    method: 'POST',
    body,
  });

export { createProduct };
